import { apiClient } from './client'

export type ReconciliacionBanding = 'OK' | 'WARNING' | 'CRITICAL'

export interface ReconciliacionResponse {
  tanque: {
    id: string
    nombre: string
    tipo: string
    capacidadLitros: number | null
    stockActual: number
  }
  periodo: { desde: string; hasta: string }
  stockInicial: number
  entradas: number
  dispensado: number
  expected: number
  actual: number
  variance: number
  variancePct: number
  banding: ReconciliacionBanding
  cargasCount: number
  alerta: string | null
}

export const reconciliacionApi = {
  getByTanque: (tanqueId: string, desde: string, hasta: string) =>
    apiClient
      .get<ReconciliacionResponse>(`/tanques/${tanqueId}/reconciliacion`, {
        params: { desde, hasta },
      })
      .then((r) => r.data),
}
